import type { Template } from "@/types";

export const PO_05_H2_V3: Template[] = [
    {
        id: "po-05-h2v3-01",
        name: "PO 01 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_01.png",
        size: [1298, 827],
        style: {},
        slots: [       
            { id: "1", x: 80, y: 165, width: 242, height: 337, rotation: 0, imageRotation: 0 },
            { id: "2", x: 330, y: 165, width: 241, height: 337, rotation: 0, imageRotation: 0 },
            { id: "3", x: 80, y: 510, width: 242, height: 152, rotation: 0, imageRotation: 0 },
            { id: "4", x: 330, y: 510, width: 241, height: 152, rotation: 0, imageRotation: 0 },
            { id: "5", x: 731, y: 73, width: 484, height: 682, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-02",
        name: "PO 02 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 31, y: 0, width: 587, height: 827, rotation: 0, imageRotation: 0 },
            { id: "2", x: 718, y: 147, width: 252, height: 361, rotation: 0, imageRotation: 0 },
            { id: "3", x: 978, y: 147, width: 251, height: 361, rotation: 0, imageRotation: 0 },
            { id: "4", x: 718, y: 516, width: 252, height: 164, rotation: 0, imageRotation: 0 },
            { id: "5", x: 978, y: 516, width: 251, height: 164, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-03",
        name: "PO 03 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 31, y: 0, width: 587, height: 827, rotation: 0, imageRotation: 0 },
            { id: "2", x: 718, y: 319, width: 252, height: 361, rotation: 0, imageRotation: 0 },
            { id: "3", x: 978, y: 147, width: 251, height: 361, rotation: 0, imageRotation: 0 },
            { id: "4", x: 718, y: 147, width: 252, height: 164, rotation: 0, imageRotation: 0 },
            { id: "5", x: 978, y: 516, width: 251, height: 164, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-04",
        name: "PO 04 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 82, y: 72, width: 484, height: 682, rotation: 0, imageRotation: 0 },
            { id: "2", x: 703, y: 156, width: 516, height: 329, rotation: 0, imageRotation: 0 },
            { id: "3", x: 703, y: 493, width: 123, height: 178, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1097, y: 493, width: 122, height: 178, rotation: 0, imageRotation: 0 },
            { id: "5", x: 834, y: 493, width: 255, height: 178, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-05",
        name: "PO 05 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 87, y: 157, width: 470, height: 302, rotation: 0, imageRotation: 0 },
            { id: "2", x: 87, y: 467, width: 310, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 405, y: 467, width: 151, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 694, y: 215, width: 276, height: 395, rotation: 0, imageRotation: 0 },
            { id: "5", x: 978, y: 215, width: 276, height: 395, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-06",
        name: "PO 06 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 59, y: 229, width: 262, height: 369, rotation: 0, imageRotation: 0 },
            { id: "2", x: 329, y: 229, width: 261, height: 369, rotation: 0, imageRotation: 0 },         
            { id: "3", x: 699, y: 229, width: 272, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 699, y: 418, width: 272, height: 180, rotation: 0, imageRotation: 0 },
            { id: "5", x: 979, y: 229, width: 271, height: 369, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-07",
        name: "PO 07 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 38, y: 200, width: 300, height: 427, rotation: 0, imageRotation: 0 },
            { id: "2", x: 346, y: 200, width: 300, height: 427, rotation: 0, imageRotation: 0 },
            { id: "3", x: 654, y: 200, width: 299, height: 427, rotation: 0, imageRotation: 0 },
            { id: "4", x: 961, y: 200, width: 299, height: 210, rotation: 0, imageRotation: 0 },
            { id: "5", x: 961, y: 418, width: 299, height: 209, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-08",
        name: "PO 08 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 153, width: 811, height: 520, rotation: 0, imageRotation: 0 },
            { id: "2", x: 819, y: 153, width: 480, height: 303, rotation: 0, imageRotation: 0 },
            { id: "3", x: 819, y: 464, width: 155, height: 209, rotation: 0, imageRotation: 0 },
            { id: "4", x: 982, y: 464, width: 154, height: 209, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1144, y: 464, width: 154, height: 209, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-09",
        name: "PO 09 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 38, y: 200, width: 300, height: 427, rotation: 0, imageRotation: 0 },
            { id: "2", x: 654, y: 200, width: 299, height: 427, rotation: 0, imageRotation: 0 },
            { id: "3", x: 961, y: 200, width: 299, height: 427, rotation: 0, imageRotation: 0 },
            { id: "4", x: 346, y: 200, width: 300, height: 210, rotation: 0, imageRotation: 0 },
            { id: "5", x: 346, y: 418, width: 300, height: 209, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h2v3-10",
        name: "PO 10 - H2V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h2_v3_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 186, width: 319, height: 455, rotation: 0, imageRotation: 0 },
            { id: "2", x: 327, y: 186, width: 318, height: 455, rotation: 0, imageRotation: 0 },
            { id: "3", x: 979, y: 186, width: 318, height: 455, rotation: 0, imageRotation: 0 },
            { id: "4", x: 653, y: 186, width: 318, height: 224, rotation: 0, imageRotation: 0 },
            { id: "5", x: 653, y: 418, width: 318, height: 223, rotation: 0, imageRotation: 0 }
        ],
    }
];